module.exports = __webpack_public_path__ + "static/media/edit.217f94f5.svg";